import { DatePipe, DOCUMENT, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartColor, ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from '../test/test-step/confirmation-dialog.service';
import { ProjectService } from '../_services/project.service';
import { ReportService } from '../_services/report.service';
import { Chart } from './latest-report/chart';
import * as moment from 'moment';
declare var bootstrap: any
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  projectId: any;
  projectReportData: any;
  projectData: Object;
  projectName: any;
  toDate :any;
  fromDate :any;
  browser= ['ALL'];
  selectedBrowser = 'ALL';
  os=  ['ALL'];
  selectedOS = 'ALL';
  includeIterationCount : boolean = false;
  detailSummaryReportData: Object;
  projectTestCaseExecutionData: any;
  suiteId: any;
  testCaseHistoryData: any;
  indexFormArray: UntypedFormArray;
  form:UntypedFormGroup;
  getIndexArray: any;
  comparedValue: any[];
  acceptedDuration = 1;
  public chartOptionSelect = ['pie','bar'];
  copyMessage: any;
  availZone = moment.tz.guess();
  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ]
  charData: any=[];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'pie';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
    }
  };
  chartList: Array<Object> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Automation Summary Report',
    data: undefined,
  }
  test1: string;
  myDate = new Date();

  constructor(
    private report: ReportService,
    private project: ProjectService,
    private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private route: ActivatedRoute,
  private router:Router,
  private toastrService:ToastrService,
  public datepipe: DatePipe,
  private confirmationDialogService:ConfirmationDialogService,
  @Inject( DOCUMENT ) private document: Document,
  ) { 
    this.test1 = this.datepipe.transform(this.myDate, 'yyyy-MM-dd');
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
  }

  ngOnInit() {
    
    this.initFromToDate();
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
       this.project.getProjectById(this.projectId).subscribe(
         (data)=>{
           this.projectData = data;
           this.headerOptions.data = { 
            projectId : this.projectId,
            projectName: data['projectName']
          };
          
         }
       )
       let endDate =  new Date(JSON.parse(JSON.stringify(this.toDate + ' 23:59:59')));
       let startDate =  new Date(JSON.parse(JSON.stringify(this.fromDate)));
      startDate.setHours(0,0,0);
       this.getProjectSummary(this.projectId,startDate,endDate,this.selectedBrowser,this.selectedOS, this.includeIterationCount);
       this.detailSummary(startDate,endDate);
        
      }
    )

    this.bootstrapToggele();
    

  }





getSummaryReport(status, count){
  // alert('hello')
  if (count === '0') {
    this.toastrService.clear();
    this.toastrService.warning("Detail report is not available");
    return;
  }
  let endDate =  new Date(JSON.parse(JSON.stringify(this.toDate)));
       endDate.setHours(23,59,59);
       let startDate =  new Date(JSON.parse(JSON.stringify(this.fromDate)));
      startDate.setHours(0,0,0);
  let fromDate = Math.floor(new Date(startDate).getTime());
  let toDate =   Math.floor(new Date(endDate).getTime());
 
  this.router.navigate(['/projectSummaryReport/'+this.projectId+'/'+fromDate+'/'+toDate+'/All/All/'+status]);
}


initFromToDate()
{
  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2,"0");
  var date  =  String(today.getDate()).padStart(2,"0")
  this.toDate = year + "-" + month + "-" + date;
  //console.log('todate',this.toDate);
  let endDate =  new Date(JSON.parse(JSON.stringify(this.toDate)));
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  
  const now = new Date();
  var lastWeek = new Date(now.getFullYear(), now.getMonth(), 1);
  var year1 = lastWeek.getFullYear();
  var month1 = String(lastWeek.getMonth() + 1).padStart(2,"0");
  var date1  =  String(lastWeek.getDate()).padStart(2,"0")
  this.fromDate = year1 + "-" + month1 + "-" + date1;
  let startDate =  new Date(JSON.parse(JSON.stringify(this.fromDate)));
  startDate.setHours(0,0,0);
  // startDate.setMinutes(00);
  // startDate.setSeconds(00);
  //console.log('fromDate',startDate);

  



  let fromDate = Math.floor(new Date(startDate).getTime());
  let toDate =   Math.floor(new Date(endDate).getTime());
  
  // var dateString = moment.unix(fromDate).format('MM/DD/YY 12:00:00 am');
  //console.log('fromdate',fromDate,'toDate',toDate);
  
  // var d = Date(this.toDate.tz(this.availZone).format('MM/DD/YY H:mm:ss')).getTime();

    // Date(toDate(this.availZone).format('MM/DD/YY H:mm:ss')).getTime();
    const unixTime = 1659292200000;
    const datedd = new Date(unixTime*1000);
    //console.log('datedd',datedd);

}

onFilterReport(updateReportForm){
  // console.log(updateReportForm.value)
  let endDate =  new Date(JSON.parse(JSON.stringify(updateReportForm.value.toDate + ' 23:59:59')));
  let startDate =  new Date(JSON.parse(JSON.stringify(updateReportForm.value.fromDate)));
  startDate.setHours(0,0,0);
  // let fromDate = Math.floor(new Date(JSON.parse(JSON.stringify(updateReportForm.value.toDate + ' 23:59:59'))).getTime());
  // let toDate =   Math.floor(new Date(JSON.parse(JSON.stringify(updateReportForm.value.fromDate))).getTime());
  console.log('from', startDate , 'to', endDate);
  let fDate = Math.floor(new Date(startDate).getTime());
  let tDate =   Math.floor(new Date(endDate).getTime());
  let e = new Date(this.test1+ ' 23:59:59').getTime();
  if(fDate > e )
  {
    this.toastrService.info('Please select current or past date');
    return;
  }
  
  if(tDate < fDate){
    this.toastrService.info('Please select end date after start date');
    return;
  }
  if(tDate > e){
    this.toastrService.info('Please select current or past date');
    return;
  }
  // this.getProjectSummary(this.projectId,updateReportForm.value.fromDate, updateReportForm.value.toDate,this.selectedBrowser,this.selectedOS, this.includeIterationCount);
  this.getProjectSummary(this.projectId,fDate, tDate,this.selectedBrowser,this.selectedOS, this.includeIterationCount);
  this.detailSummary(fDate,tDate);
 
}
selectChartType(chartType){
  this.barChartType = chartType;
}
getBrowser(){
  //console.log('browser',this.projectReportData['testExecutionStats']);
  var br = []
  for(let b of this.projectReportData['testExecutionStats']){
    br.push(b);
  }
  //console.log('br',br);
  
  var suiteData = this.removeDuplicates(br,'browser');
  //console.log('brrr',suiteData);
  
  for(let d of suiteData){
    this.browser.push(d.browser);
  }
  
}

getOs(){

  var osData = []
  for(let b of this.projectReportData['testExecutionStats']){
    osData.push(b);
  }
  //console.log('br',osData);
  
  var suiteData = this.removeDuplicates(osData,'os');
  //console.log('brrr',suiteData);
  
  for(let d of suiteData){
    this.os.push(d.os);
  }

}

bootstrapToggele(){
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    
  return new bootstrap.Tooltip(tooltipTriggerEl)
  })
}

removeDuplicates(originalArray, prop) {
  var newArray = [];
  var lookupObject  = {};

  for(var i in originalArray) {
     lookupObject[originalArray[i][prop]] = originalArray[i];
  }

  for(i in lookupObject) {
      newArray.push(lookupObject[i]);
  }
  //console.log('newArray',newArray);
  
   return newArray;
}

getProjectSummary(projectid,fromDate,toDate,browser,os, check){
  //console.log("before sending : ", fromDate, toDate)

  let fDate = Math.floor(new Date(fromDate).getTime());
  let tDate =   Math.floor(new Date(toDate).getTime());

  console.log('browser',browser);

  console.log('os',os);
  

  this.report.getProjectReport(projectid,fDate,tDate,browser,os, check).subscribe((
    data=>{
      this.projectReportData={};
      this.chartList = [];
      this.blinkArry = [];
      this.projectReportData=data;
      this.browser = ['ALL'];
      this.os = ['ALL'];
      this.getBrowser();
      this.getOs();
      var projectSummary = this.projectReportData['projectLevelSummary'];
        let chartObj = new Object();
        chartObj['pass'] = projectSummary.pass;
        chartObj['fail'] = projectSummary.fail;
        chartObj['blocked'] = projectSummary.blocked;
        chartObj['inconclusive'] = projectSummary.inconclusive;
        chartObj['notRun'] = projectSummary.notRun;
        chartObj['skipped'] = projectSummary.skipped;
        this.chartList.push(chartObj);
      this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
      for(let c of this.chartList){
        this.blinkArry.push(Object.values(c));
      }
      this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
      const toNumbers = arr => arr.map(Number);
       var n = toNumbers(this.numarray);
      this.barChartData = [{ data:  n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors,categoryPercentage: projectSummary.percentage}];
    }
  ))
}


detailSummary(fDate,tDate){

  let startDate =  new Date(JSON.parse(JSON.stringify(fDate )));
  startDate.setHours(0,0,0);

  let endDate =  new Date(JSON.parse(JSON.stringify(tDate)));
  endDate.setHours(23,59,59);
  let fromDate = Math.floor(new Date(fDate).getTime());
  let toDate =   Math.floor(new Date(tDate).getTime());

  this.report.projectDetailSummary(this.projectId,fromDate,toDate,this.selectedBrowser,this.selectedOS).subscribe(
    (data)=>{
      this.detailSummaryReportData = data;
      console.log('detailSummary',this.detailSummaryReportData);
    }  )
 
}
projectTestCaseExecutionSummary(suiteId){
  this.suiteId = suiteId;
  let startDate =  new Date(JSON.parse(JSON.stringify(this.fromDate)));
  startDate.setHours(0,0,0);

  let endDate =  new Date(JSON.parse(JSON.stringify(this.toDate)));
  endDate.setHours(23,59,59);
  let fDate = Math.floor(new Date(startDate).getTime());
  let tDate =   Math.floor(new Date(endDate).getTime());
  this.report.projectTestCaseExecutionSummary(this.projectId,fDate,tDate,this.selectedBrowser,this.selectedOS,suiteId).subscribe(
    (data)=>{
   this.projectTestCaseExecutionData = data['testExecutionStats'];
   //console.log(this.projectTestCaseExecutionData);
  })
}

testCaseHistory(caseId){
  let startDate =  new Date(JSON.parse(JSON.stringify(this.fromDate)));
  startDate.setHours(0,0,0);

  let endDate =  new Date(JSON.parse(JSON.stringify(this.toDate)));
  endDate.setHours(23,59,59);
  let fDate = Math.floor(new Date(startDate).getTime());
  let tDate =   Math.floor(new Date(endDate).getTime());

this.report.testCaseHistory(this.projectId,fDate,tDate,this.selectedBrowser,this.selectedOS,caseId,this.suiteId).subscribe(
  (data=>{
    this.testCaseHistoryData = data['testExecutionStats'];
    //console.log(this.testCaseHistoryData);
  })
)
}
moveToSelectedTab(tabName: string) {
  for (let i =0; i< document.querySelectorAll('.mat-tab-label-content').length; i++) {
  if ((<HTMLElement>document.querySelectorAll('.mat-tab-label-content')[i]).innerText == tabName) 
     {
        (<HTMLElement>document.querySelectorAll('.mat-tab-label')[i]).click();
     }
   }
}

onChange(index:string, isChecked: boolean) {
  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;

  if(isChecked) {
    this.indexFormArray.push(new UntypedFormControl(index));
    //console.log(this.indexFormArray.value);
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == index);
    this.indexFormArray.removeAt(Index);
    //console.log(this.indexFormArray.value)
  }
}
async compareStep(){

  //console.log(this.indexFormArray);
  if(this.indexFormArray.length > 2)
  {
    this.toastrService.error('Please select only 2 executions and try again');
    return;
  }
  if(this.indexFormArray==undefined){
    this.toastrService.clear();
this.toastrService.info('Please select atleast 2 execution');
return;
  }
 else if(this.indexFormArray.value.length<2){
this.toastrService.clear();
this.toastrService.info('Please select atleast 2 execution');
return;
  }
  var dataForComare=[]
  
for(let i=0;i< this.indexFormArray.value.length;i++){
  const promise = await this.report.getStepExecutionInfo(this.projectId,this.indexFormArray.value[i]).toPromise().then((data)=>{
    if(data){
      dataForComare.push(data)
    }
   else{
     return;
   }
  })
}
//console.log(dataForComare);
this.comparedValue =this.processStepInfo(dataForComare[0].testStepReport,dataForComare[1].testStepReport,this.acceptedDuration)
//console.log(this.comparedValue);
this.moveToSelectedTab("Execution Comparison Report");
}
updateDuration(value){
//console.log(value);
this.acceptedDuration = value;
}
processStepInfo(testStepReports1, testStepReports2, acceptedDuration) {
  var returnValue = [];
  for (var i = 0; i < testStepReports1.length; i++) {
     var testStep1 = testStepReports1[i];
      var testStep2 = testStepReports2[i];
      var isDifferent = false;

      testStep1.action1 = testStep2.action;
      testStep1.pageName1 = testStep2.pageName;
      testStep1.parameters1 = testStep2.parameters;
      testStep1.resultState1 = testStep2.resultState;
      testStep1.duration1 = testStep2.duration;
      testStep1.testData1 = testStep2.testData;

      testStep1.isactionDiff = false;
      if (testStep1.action !== testStep2.action) {
          isDifferent = true;
          testStep1.isactionDiff = true;
      }

      testStep1.isPageNameDiff = false;
      if (testStep1.pageName !== testStep2.pageName) {
          isDifferent = true;
          testStep1.isPageNameDiff = true;
      }

      testStep1.isParametersDiff = false;
      if (testStep1.parameters !== testStep2.parameters) {
          isDifferent = true;
          testStep1.isParametersDiff = true;
      }

      testStep1.isTestDataDiff = false;
      if (testStep1.testData !== testStep2.testData) {
          isDifferent = true;
          testStep1.isTestDataDiff = true;
      }

      testStep1.isStatusDiff = false;
      if (testStep1.resultState.status !== testStep2.resultState.status) {
          isDifferent = true;
          testStep1.isStatusDiff = true;
      }

      testStep1.duration = (testStep1.endTime - testStep1.startTime);
      if (testStep1.duration > 0) {
          testStep1.duration = testStep1.duration / 1000;
      }
      testStep2.duration = (testStep2.endTime - testStep2.startTime);

      if (testStep2.duration > 0) {
          testStep2.duration = testStep2.duration / 1000;
      }
      testStep1.duration1 = testStep2.duration;
      testStep1.isDurationDiff = false;

      if ((((testStep1.duration - testStep2.duration) > acceptedDuration) ||
              ((testStep2.duration - testStep1.duration) > acceptedDuration))) {
          isDifferent = true;
          testStep1.isDurationDiff = true;
      }
      testStep1.isDifferent = isDifferent;
      returnValue.push(testStep1);
  }
  return returnValue;
}
}
